import React from "react";
import Loader from "../Common/Loader";

function VendorCommissions({commissions, loading4}) {
    return (
        <>
            <div className="border-top mt-1"></div>
            <div className="table-responsive">
                {loading4 ? (
                    <Loader /> 
                ) : (
                    <table className="table display data-table text-nowrap">
                        <thead>
                            <tr>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Commission Type</th> 
                            <th>Transaction Number</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            {commissions.length > 0 ? (
                                commissions.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.created_at?.short_date}<br /><small>{item.created_at?.time}</small></td>                                          
                                    
                                    
                                    <td>
                                        <span class="badge bg-teal">
                                            {item.type === "Withdraw"?
                                            <i class="fa fa-circle-arrow-down text-teal fs-9px fa-fw me-5px" style={{ color: "#dc3545" }}></i>:
                                            <i class="fa fa-circle-arrow-up text-teal fs-9px fa-fw me-5px" style={{ color: "#28a745" }}></i>    
                                            }
                                        </span>
                                        UGX.{" "}
                                        {item.amount}<br/>
                                        <small>
                                        {item.description}
                                        </small>
                                        
                                    </td>
                                    <td>
                                        <span class="badge badge-primary">
                                        {item.account}
                                        </span>
                                    </td>
                                    <td>{item.transaction_number}</td>

                                </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No commissions for this vendor yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        
        </>
        
    );
}

export default VendorCommissions;
